import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import coreService from "@/utils/axios/core-service";
import { API_ENDPOINTS, RESPONSE_STATUSES } from "@/constants/api-endpoints";
import { MARKET_PLACES } from "@/constants/app";

//  Fetch all eBay discount setting data
export const fetchShippingSettingsData = createAsyncThunk(
  "shippingSettings/fetchAll",
  async ({ page = 0, size = 100, body = [] } = {}, thunkAPI) => {
    try {
      const response = await coreService.post(
        `${API_ENDPOINTS.ADMIN.SETTINGS.SHIPPING.GET_ALL}?page=${page}&size=${size}&sort=id,asc`,
        body
      );

      if (response.data?.status == RESPONSE_STATUSES.SUCCESS) {
        return response.data?.data?.content || [];
      }

      return thunkAPI.rejectWithValue("Unexpected response from server");
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.message || "API error");
    }
  }
);
export const createOrUpdateShippingSettings = createAsyncThunk(
  "shippingSettings/createOrUpdateShippingSettings",
  async ({ payload, page, size, t }, thunkAPI) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await coreService.post(
          API_ENDPOINTS.ADMIN.SETTINGS.SHIPPING.CREATE,
          payload
        );

        if (response.data.status == RESPONSE_STATUSES.CREATED) {
          // 🔥 Refetch after success
          thunkAPI.dispatch(fetchShippingSettingsData({ page, size }));

          resolve(t("shippingSettingsUpdateSuccesfully"));
        } else {
          reject(t("failedToUpdateShippingSettings"));
        }
      } catch (err) {
        reject(err?.message);
      }
    });
  }
);
//  Slice
const shippingSettingsSlice = createSlice({
  name: "shippingSettings",
  initialState: {
    shippingSettingsData: [],
    shippingSettingsLoading: false,
    shippingSettingsError: null,
    submitLoading: false,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchShippingSettingsData.pending, (state) => {
        state.shippingSettingsLoading = true;
        state.shippingSettingsError = null;
      })
      .addCase(fetchShippingSettingsData.fulfilled, (state, action) => {
        state.shippingSettingsLoading = false;
        state.shippingSettingsData = action.payload;
      })
      .addCase(fetchShippingSettingsData.rejected, (state, action) => {
        state.shippingSettingsLoading = false;
        state.shippingSettingsError = action.payload;
        state.shippingSettingsData = [];
      })
      // SUBMIT
      .addCase(createOrUpdateShippingSettings.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(createOrUpdateShippingSettings.fulfilled, (state) => {
        state.submitLoading = false;
      })
      .addCase(createOrUpdateShippingSettings.rejected, (state) => {
        state.submitLoading = false;
      });
  },
});

export default shippingSettingsSlice.reducer;
